// Import our custom CSS
import '../scss/styles.scss';
//import { createApp,ref } from "vue/dist/vue.esm-bundler.js";
//var $ = require( "jquery");
import $ from 'jquery';
import Chart from 'chart.js/auto';
import * as bootstrap from 'bootstrap';
require('jquery-validation');
require('jquery-countdown');


window.jQuery = $;
window.$ = $;
//window.Chart = Chart;
$(document).ready(function() {
    //$("form").validate(); // Inizializza la validazione
    console.log("ready");
});

require ('./common.js');
import './membership.js';
import './bootstrap-datepicker.js';
import './custom.js';
import './jquery.uploadfile.js';

/*import './slick.min.js';*/

import './bootstrap-datepicker.js';
// Import all of Bootstrap's JS*/
